// Live's legal pages on the created.ai marketing site, which sign-in and the cookie banner link
// until we publish our own (design-system decision 30; spec web/cookie-consent). The privacy
// policy's section 7 is live's cookie policy.
export const TERMS_URL = "https://created.ai/terms/";
export const PRIVACY_POLICY_URL = "https://created.ai/privacy/";
